import { render, staticRenderFns } from "./role-list.vue?vue&type=template&id=6289c026"
import script from "./role-list.vue?vue&type=script&lang=js"
export * from "./role-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports